module.exports = __webpack_public_path__ + "img/shopping_survey.214f3618.png";